import React, { Component } from 'react';
import {createSelector} from "reselect";
import {connect} from "react-redux";
import { Main } from '../../layout';

class HowItWork extends Component {
    render() {
        return (<Main>
            sdfds
        </Main>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(HowItWork);